"use strict";Object.defineProperty(exports, "__esModule", {value: true});// Mobile reports when the app goes to the background and back; null means
// the platform doesn't report (web and desktop, whose "inactive" is an idle
// user, not a hidden app). A suspended app can do nothing about what it was
// waiting for, so a send's clocks count only foreground time.
let appInBackground = null
// How many times the app has gone to the background, so a failure report can
// say whether it went there since Send.
let backgroundTrips = 0
const listeners = new Set()

 const setAppInBackground = (inBackground) => {
  if (inBackground && !appInBackground) backgroundTrips++
  appInBackground = inBackground
  listeners.forEach(listener => listener(!!inBackground))
}; exports.setAppInBackground = setAppInBackground

 const isAppInBackground = () => !!appInBackground; exports.isAppInBackground = isAppInBackground
 const isAppStateReported = () => appInBackground !== null; exports.isAppStateReported = isAppStateReported
 const getBackgroundTrips = () => backgroundTrips; exports.getBackgroundTrips = getBackgroundTrips

// Calls onExpiry once `ms` of foreground time has passed: the clock stops
// while the app is in the background and resumes with what was left. Returns
// a cancel function.
 const foregroundTimeout = (ms, onExpiry) => {
  let leftMs = ms
  // When the clock last started counting; null while paused.
  let since = null
  let timer
  const count = () => {
    if (since !== null || appInBackground) return
    since = Date.now()
    timer = setTimeout(() => {
      cancel()
      onExpiry()
    }, leftMs)
  }
  const pause = () => {
    clearTimeout(timer)
    if (since === null) return
    leftMs -= Date.now() - since
    since = null
  }
  const onAppState = (inBackground) => inBackground ? pause() : count()
  const cancel = () => {
    clearTimeout(timer)
    listeners.delete(onAppState)
  }
  listeners.add(onAppState)
  count()
  return cancel
}; exports.foregroundTimeout = foregroundTimeout
